import { useState, useRef, useEffect } from 'react';
import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import SearchIcon from '@mui/icons-material/Search';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { t } from './../i18n';
import './QueryMaker.css';

function replaceDotsExceptFirst(field) {
    if (!field || !field.columnName) return '';
    let str = field.columnName;
    let lastDotIndex = str.lastIndexOf('.');
   // Αν δεν υπάρχει τελεία
    if (lastDotIndex === -1) {
        return field.prefix + '.' + str;
    }
    let beforeLastDot = str.slice(0, lastDotIndex).replace(/\./g, '_');
    let afterLastDot = str.slice(lastDotIndex); // κρατάμε την τελευταία τελεία
    return beforeLastDot + afterLastDot;
}
    /*
    
    let firstDotIndex = str.indexOf('.');
    if (firstDotIndex === -1) {
        return field.prefix + '.' + str;
    }
    let beforeFirstDot = str.slice(0, firstDotIndex + 1);
    let afterFirstDot = str.slice(firstDotIndex + 1).replace(/\./g, '_');
    return beforeFirstDot + afterFirstDot;
        */


function QueryMaker({ queryText, setQueryText, language, showContextMenu, setShowContextMenu }) {
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [optionModal, setOptionModal] = useState({ visible: false, title: '' });
    const queryTextAreaRef = useRef(null);

    useEffect(() => {
        if (showContextMenu && queryTextAreaRef.current) {
            const rect = queryTextAreaRef.current.getBoundingClientRect();
            const centerX = rect.left + rect.width / 4;
            const centerY = 175;

            setMenuAnchor({
                mouseX: centerX,
                mouseY: centerY
            });
            setShowContextMenu(false);
        }
    }, [showContextMenu, setShowContextMenu]);

    const [simpleParam, setSimpleParam] = useState({
        caption: '',
        dataType: 'Variable Length String',
        size: 0,
        precision: 0,
        scale: 0
    });

    const [comboOptions, setComboOptions] = useState(['']);

    const [comboParam, setComboParam] = useState({
        caption: ''
    });

    const [dropdownParam, setDropdownParam] = useState({
        caption: '',
        options: '',
        currentOption: ''
    });

    const [checkboxParam, setCheckboxParam] = useState({
        caption: ''
    });

    const dataTypeOptions = [
        'Variable Length String',
        'Fixed Length String',
        'Numeric',
        'Date'
    ];

    function handleContextMenu(e) {
        e.preventDefault();
        setMenuAnchor({ mouseX: e.clientX + 2, mouseY: e.clientY - 6 });
    }

    function handleComboParamChange(e) {
        const { name, value } = e.target;
        setComboParam(prev => ({
            ...prev,
            [name]: value
        }));
    }

    function handleComboOptionChange(index, value) {
        const newOptions = [...comboOptions];
        newOptions[index] = value;
        setComboOptions(newOptions);
    }

    function addComboOption() {
        setComboOptions([...comboOptions, '']);
    }

    function removeComboOption(index) {
        const newOptions = comboOptions.filter((_, i) => i !== index);
        setComboOptions(newOptions);
    }

    function handleComboParamOk() {
        const syntax = `?Combo(${comboParam.caption};${comboOptions.join(',')})`;

        if (window.lastFieldToAppend) {
            const { field, operator } = window.lastFieldToAppend;
            let newQuery = queryText ? queryText + "\nAND " : "";

            if (operator === 'DATE_RANGE') {
                const fieldName = replaceDotsExceptFirst(field);
                newQuery += `({${fieldName}} >= ${syntax} and {${fieldName}} < ${syntax}+1)`;
            } else {
                newQuery += '{' + replaceDotsExceptFirst(field) + '}';
                if (operator === '=') newQuery += ' = ' + syntax;
                else if (operator === 'LIKE') newQuery += " LIKE " + syntax + "||'%'";
                else newQuery += ' ' + syntax;
            }

            setQueryText(newQuery);
            window.lastFieldToAppend = null;
        } else {
            const startPos = queryTextAreaRef.current.selectionStart;
            const endPos = queryTextAreaRef.current.selectionEnd;
            const textBefore = queryText.substring(0, startPos);
            const textAfter = queryText.substring(endPos);
            setQueryText(textBefore + syntax + textAfter);
        }

        setOptionModal({ visible: false, title: '' });
        setComboParam({ caption: '' });
        setComboOptions(['']);
    }

    function handleComboParamCancel() {
        setOptionModal({ visible: false, title: '' });
        setComboParam({ caption: '' });
        setComboOptions(['']);
    }

    function handleMenuOption(option) {
        let title = '';
        if (option === 'simple') {
            title = 'Add Simple Parameter';
            if (window.lastFieldToAppend?.field) {
                const fieldType = window.lastFieldToAppend.field.dataType;
                let dataType = 'Variable Length String';

                if (fieldType === 'DateTime' || fieldType === 'Date') {
                    dataType = 'Date';
                } else if (fieldType === 'Int32' || fieldType === 'Decimal' || fieldType === 'Double' || fieldType === 'Int64') {
                    dataType = 'Numeric';
                } else if (fieldType === 'String' && window.lastFieldToAppend.field.size > 0) {
                    dataType = 'Fixed Length String';
                }

                setSimpleParam(prev => ({
                    ...prev,
                    dataType: dataType
                }));
            }
        } else if (option === 'combo') {
            title = 'Add Combo-Box Parameter';
            if (comboOptions.length === 0) {
                setComboOptions(['']);
            }
        }
        else if (option === 'dropdown') title = 'Add Drop-Down Parameter';
        else if (option === 'combo') title = 'Add Combo-Box Parameter';
        else if (option === 'checkbox') title = 'Add Check-Box Parameter';
        else if (option === 'lookup') title = 'Add Look-Up Parameter';
        else if (option === 'subquery') title = 'Add SubQuery';
        setOptionModal({ visible: true, title });
        setMenuAnchor(null);
    }

    function handleSimpleParamChange(e) {
        const { name, value } = e.target;
        if (name === 'dataType') {
            // let cleared = { dataType: value };
            // if (value === 'Variable Length String') {
            //     cleared.size = prev => prev.size;
            //     cleared.precision = 0;
            //     cleared.scale = 0;
            // } else if (value === 'Fixed Length String' || value === 'Numeric') {
            //     cleared.size = 0;
            //     cleared.precision = prev => prev.precision;
            //     cleared.scale = prev => prev.scale;
            // } else if (value === 'Date') {
            //     cleared.size = 0;
            //     cleared.precision = 0;
            //     cleared.scale = 0;
            // }
            // setSimpleParam(prev => ({
            //     ...prev,
            //     ...Object.fromEntries(Object.entries(cleared).map(([k, v]) => [k, typeof v === 'function' ? v(prev) : v]))
            // }));
            const resetState = {
                ...simpleParam,
                dataType: value,
                size: 0,
                precision: 0,
                scale: 0
            };
            setSimpleParam(resetState);
        } else {
            setSimpleParam(prev => ({ ...prev, [name]: value }));
        }
    }

    function handleSimpleParamOk() {
        const syntax = getParameterSyntax(simpleParam);
        if (syntax) {
            if (window.lastFieldToAppend) {
                const { field, operator } = window.lastFieldToAppend;
                let newQuery = queryText ? queryText + "\nAND " : "";

                if (operator === 'DATE_RANGE') {
                    const fieldName = replaceDotsExceptFirst(field);
                    newQuery += `({${fieldName}} >= ${syntax} and {${fieldName}} < ${syntax}+1)`;
                } else {
                    newQuery += '{' + replaceDotsExceptFirst(field) + '}';
                    if (operator === '=') newQuery += ' = ' + syntax;
                    else if (operator === 'LIKE') newQuery += " LIKE " + syntax + "||'%'";
                    else newQuery += ' ' + syntax;
                }

                setQueryText(newQuery);
                window.lastFieldToAppend = null;
            } else {
                setQueryText(prev => (prev ? prev + '\n' + syntax : syntax));
            }
        }
        setSimpleParam({
            caption: '',
            dataType: 'Variable Length String',
            size: 0,
            precision: 0,
            scale: 0
        });
        setOptionModal({ ...optionModal, visible: false });
    }

    function handleSimpleParamCancel() {
        setSimpleParam({
            caption: '',
            dataType: 'Variable Length String',
            size: 0,
            precision: 0,
            scale: 0
        });
        setOptionModal({ ...optionModal, visible: false });
    }

    function getParameterSyntax(param) {
        let typeChar = 's';
        if (param.dataType === 'Variable Length String') typeChar = 's';
        else if (param.dataType === 'Fixed Length String') typeChar = 'c';
        else if (param.dataType === 'Numeric') typeChar = 'n';
        else if (param.dataType === 'Date') typeChar = 'd';
        let parts = [param.caption || '', typeChar];
        if (param.dataType === 'Fixed Length String') {
            if (param.size) parts.push(param.size);
        } else if (param.dataType === 'Numeric') {
            if (param.precision && param.scale) {
                parts.push(`${param.precision}.${param.scale}`);
            } else if (param.precision) {
                parts.push(param.precision);
            } else if (param.scale) {
                parts.push(`0.${param.scale}`);
            }
        }
        return `?(${parts.join(';')})`;
    }

    function handleCheckboxParamChange(e) {
        const { name, value } = e.target;
        setCheckboxParam(prev => ({ ...prev, [name]: value }));
    }

    function handleCheckboxParamOk() {
        const syntax = `?Check(${checkboxParam.caption})`;

        if (window.lastFieldToAppend) {
            const { field, operator } = window.lastFieldToAppend;
            let newQuery = queryText ? queryText + "\nAND " : "";

            if (operator === 'DATE_RANGE') {
                const fieldName = replaceDotsExceptFirst(field);
                newQuery += `({${fieldName}} >= ${syntax} and {${fieldName}} < ${syntax}+1)`;
            } else {
                newQuery += '{' + replaceDotsExceptFirst(field) + '}';
                if (operator === '=') newQuery += ' = ' + syntax;
                else if (operator === 'LIKE') newQuery += " LIKE " + syntax + "||'%'";
                else newQuery += ' ' + syntax;
            }

            setQueryText(newQuery);
            window.lastFieldToAppend = null;
        } else {
            setQueryText(prev => (prev ? prev + '\n' + syntax : syntax));
        }

        setCheckboxParam({ caption: '' });
        setOptionModal({ ...optionModal, visible: false });
    }

    function handleCheckboxParamCancel() {
        setCheckboxParam({ caption: '' });
        setOptionModal({ ...optionModal, visible: false });
    }

    function handleDropdownParamChange(e) {
        const { name, value } = e.target;
        setDropdownParam(prev => ({ ...prev, [name]: value }));
    }

    function handleDropdownParamOk() {
        const filteredOptions = dropdownOptions.filter(opt => opt.key || opt.value);
        const options = filteredOptions.map(opt => `${opt.key}.${opt.value}`).join(';');
        const syntax = `?DropDown(${dropdownParam.caption};${options})`;

        if (window.lastFieldToAppend) {
            const { field, operator } = window.lastFieldToAppend;
            let newQuery = queryText ? queryText + "\nAND " : "";

            if (operator === 'DATE_RANGE') {
                const fieldName = replaceDotsExceptFirst(field);
                newQuery += `({${fieldName}} >= ${syntax} and {${fieldName}} < ${syntax}+1)`;
            } else {
                newQuery += '{' + replaceDotsExceptFirst(field) + '}';
                if (operator === '=') newQuery += ' = ' + syntax;
                else if (operator === 'LIKE') newQuery += " LIKE " + syntax + "||'%'";
                else newQuery += ' ' + syntax;
            }

            setQueryText(newQuery);
            window.lastFieldToAppend = null;
        } else {
            setQueryText(prev => (prev ? prev + '\n' + syntax : syntax));
        }

        setDropdownParam({ caption: '', options: '', currentOption: '' });
        setDropdownOptions([{ key: '', value: '' }]);
        setOptionModal({ ...optionModal, visible: false });
    }

    function handleDropdownParamCancel() {
        setDropdownParam({ caption: '', options: '', currentOption: '' });
        setDropdownOptions([{ key: '', value: '' }]);
        setOptionModal({ ...optionModal, visible: false });
    }

    const [dropdownOptions, setDropdownOptions] = useState([{ key: '', value: '' }]);

    function handleDropdownOptionChange(index, field, value) {
        const newOptions = [...dropdownOptions];
        newOptions[index][field] = value;
        setDropdownOptions(newOptions);
    }

    function addDropdownOption() {
        setDropdownOptions([...dropdownOptions, { key: '', value: '' }]);
    }

    function removeDropdownOption(index) {
        const newOptions = dropdownOptions.filter((_, i) => i !== index);
        setDropdownOptions(newOptions);
    }

    function renderDropdownParameterForm() {
        return (
            <Form>
                <div className="dropdown-form-container">
                    <Form.Group className="mb-3">
                        <Form.Label>Caption:</Form.Label>
                        <Form.Control
                            type="text"
                            name="caption"
                            value={dropdownParam.caption}
                            onChange={handleDropdownParamChange}
                            autoFocus
                            placeholder="Enter caption"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Drop-Down Options:</Form.Label>
                        <div className="pt-2">
                            {dropdownOptions.map((option, index) => (
                                <div key={index} className="dropdown-option-row">
                                    <Form.Control
                                        type="text"
                                        value={option.key}
                                        onChange={(e) => handleDropdownOptionChange(index, 'key', e.target.value)}
                                        placeholder="Key"
                                        className="dropdown-key-input"
                                    />
                                    <Form.Control
                                        type="text"
                                        value={option.value}
                                        onChange={(e) => handleDropdownOptionChange(index, 'value', e.target.value)}
                                        placeholder="Value"
                                        className="dropdown-value-input"
                                    />
                                    {index > 0 && (
                                        <span className="delete-icon" style={{ padding: "5px 9px" }} onClick={() => removeDropdownOption(index)}>
                                            <i className="bi bi-ban"></i>
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                        <Button
                            onClick={addDropdownOption}
                            className="button-add-task m-0"

                        >
                            <i className="bi bi-plus-circle"></i>
                            Add options
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Syntax:</Form.Label>
                        <Form.Control
                            type="text"
                            value={`?DropDown(${dropdownParam.caption};${dropdownOptions
                                .filter(opt => opt.key || opt.value)
                                .map(opt => `${opt.key}.${opt.value}`)
                                .join(',')})`}
                            readOnly
                            className="syntax-display"
                        />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="secondary"
                        onClick={handleDropdownParamCancel}
                        className="query-wizard-btn query-wizard-btn-secondary"
                    >
                        {t('common.cancel', language)}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleDropdownParamOk}
                        className="query-wizard-btn query-wizard-btn-primary"
                        disabled={!dropdownParam.caption?.trim()}
                    >
                        {t('common.apply', language)}
                    </Button>
                </div>
            </Form>
        );
    }

    function renderComboParameterForm() {
        return (
            <Form>
                <div className="dropdown-form-container">
                    <Form.Group className="mb-3">
                        <Form.Label>Caption:</Form.Label>
                        <Form.Control
                            type="text"
                            name="caption"
                            value={comboParam.caption}
                            onChange={handleComboParamChange}
                            autoFocus
                            placeholder="Enter caption"
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Combo-Box Options:</Form.Label>
                        <div className="pt-2">
                            {comboOptions.map((option, index) => (
                                <div key={index} className="dropdown-option-row">
                                    <Form.Control
                                        type="text"
                                        value={option}
                                        onChange={(e) => handleComboOptionChange(index, e.target.value)}
                                        placeholder="Option"
                                        className="w-100"
                                    />
                                    {index > 0 && (
                                        <span className="delete-icon" style={{ padding: "5px 9px" }} onClick={() => removeComboOption(index)}>
                                            <i className="bi bi-ban"></i>
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>
                        <Button
                            onClick={addComboOption}
                            className="button-add-task m-0"
                        >
                            <i className="bi bi-plus-circle"></i>
                            Add option
                        </Button>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Syntax:</Form.Label>
                        <Form.Control
                            type="text"
                            value={`?Combo(${comboParam.caption};${comboOptions.join(',')})`}
                            readOnly
                            className="syntax-display"
                        />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="secondary"
                        onClick={handleComboParamCancel}
                        className="query-wizard-btn query-wizard-btn-secondary"
                    >
                        {t('common.cancel', language)}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleComboParamOk}
                        className="query-wizard-btn query-wizard-btn-primary"
                        disabled={!comboParam.caption?.trim()}
                    >
                        {t('common.apply', language)}
                    </Button>
                </div>
            </Form>
        );
    }

    function renderCheckboxParameterForm() {
        return (
            <Form>
                <div style={{ padding: "25px 10px" }}>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Caption:</Form.Label>
                        <Form.Control
                            type="text"
                            name="caption"
                            value={checkboxParam.caption}
                            onChange={handleCheckboxParamChange}
                            autoFocus
                        />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Syntax:</Form.Label>
                        <Form.Control
                            type="text"
                            value={`?Check(${checkboxParam.caption})`}
                            readOnly
                            style={{ fontFamily: 'monospace', background: '#f5f5f5', fontWeight: 500 }}
                        />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="secondary"
                        onClick={handleCheckboxParamCancel}
                        className="query-wizard-btn query-wizard-btn-secondary"
                    >
                        {t('common.cancel', language)}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleCheckboxParamOk}
                        className="query-wizard-btn query-wizard-btn-primary"
                        disabled={!checkboxParam.caption?.trim()}
                    >
                        {t('common.apply', language)}
                    </Button>
                </div>
            </Form>
        );
    }

    function renderSimpleParameterForm() {
        const { dataType } = simpleParam;
        return (
            <Form>
                <div style={{ padding: "25px 10px" }}>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Caption:</Form.Label>
                        <Form.Control
                            type="text"
                            name="caption"
                            value={simpleParam.caption}
                            onChange={handleSimpleParamChange}
                            autoFocus
                        />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>DataType:</Form.Label>
                        <Form.Select
                            name="dataType"
                            value={simpleParam.dataType}
                            onChange={handleSimpleParamChange}
                        >
                            {dataTypeOptions.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Size:</Form.Label>
                        <Form.Control
                            type="number"
                            name="size"
                            value={simpleParam.size}
                            onChange={handleSimpleParamChange}
                            disabled={dataType !== 'Fixed Length String'}
                        />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Precision:</Form.Label>
                        <Form.Control
                            type="number"
                            name="precision"
                            value={simpleParam.precision}
                            onChange={handleSimpleParamChange}
                            disabled={dataType !== 'Numeric'}
                        />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Scale:</Form.Label>
                        <Form.Control
                            type="number"
                            name="scale"
                            value={simpleParam.scale}
                            onChange={handleSimpleParamChange}
                            disabled={dataType !== 'Numeric'}
                        />
                    </Form.Group>
                    <Form.Group style={{ marginBottom: 12 }}>
                        <Form.Label>Syntax:</Form.Label>
                        <Form.Control
                            type="text"
                            value={getParameterSyntax(simpleParam)}
                            readOnly
                            style={{ fontFamily: 'monospace', background: '#f5f5f5', fontWeight: 500 }}
                        />
                    </Form.Group>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button
                        variant="secondary"
                        onClick={handleSimpleParamCancel}
                        className="query-wizard-btn query-wizard-btn-secondary"
                    >
                        {t('common.cancel', language)}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSimpleParamOk}
                        className="query-wizard-btn query-wizard-btn-primary"
                        disabled={
                            !simpleParam.caption?.trim() ||
                            (simpleParam.dataType === 'Fixed Length String' && (!simpleParam.size || simpleParam.size <= 0)) ||
                            (simpleParam.dataType === 'Numeric' && (!simpleParam.precision || simpleParam.precision <= 0))
                        }
                    >
                        {t('common.apply', language)}
                    </Button>
                </div>
            </Form>
        );
    }

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <Form.Control
                as="textarea"
                ref={queryTextAreaRef}
                style={{ height: "100%" }}
                placeholder={t('toolkit.filterExpression', language)}
                value={queryText}
                onChange={e => setQueryText(e.target.value)}
                onContextMenu={handleContextMenu}
            />
            <Menu
                open={!!menuAnchor}
                className='calendar-event-menu'
                onClose={() => setMenuAnchor(null)}
                anchorReference="anchorPosition"
                anchorPosition={menuAnchor ? { top: menuAnchor.mouseY, left: menuAnchor.mouseX } : undefined}
            >
                <MenuItem onClick={() => handleMenuOption('simple')}>
                    <TextFieldsIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add Simple Parameter
                </MenuItem>
                <MenuItem onClick={() => handleMenuOption('dropdown')}>
                    <ArrowDropDownCircleIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add Drop-Down Parameter
                </MenuItem>
                <MenuItem onClick={() => handleMenuOption('combo')}>
                    <ViewWeekIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add Combo-Box Parameter
                </MenuItem>
                <MenuItem onClick={() => handleMenuOption('checkbox')}>
                    <CheckBoxIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add Check-Box Parameter
                </MenuItem>
                <MenuItem onClick={() => handleMenuOption('lookup')}>
                    <SearchIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add Look-Up Parameter
                </MenuItem>
                <MenuItem onClick={() => handleMenuOption('subquery')}>
                    <SubtitlesIcon sx={{ fontSize: 20, marginRight: 1, color: "var(--color-main-background)" }} /> Add SubQuery
                </MenuItem>
            </Menu>

            <Modal show={optionModal.visible} onHide={() => setOptionModal({ ...optionModal, visible: false })}>
                <Modal.Header closeButton>
                    <Modal.Title>{optionModal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {optionModal.title === 'Add Simple Parameter' ? renderSimpleParameterForm() :
                        optionModal.title === 'Add Check-Box Parameter' ? renderCheckboxParameterForm() :
                            optionModal.title === 'Add Drop-Down Parameter' ? renderDropdownParameterForm() :
                                optionModal.title === 'Add Combo-Box Parameter' ? renderComboParameterForm() : null}
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default QueryMaker;
